import { AfterViewInit, Component } from '@angular/core';
import { SnackService } from '../../service/snack.service';
import { DeletionService } from '../../service/deletion.service';

@Component({
  selector: 'app-confirm-deletion',
  standalone: false,
  templateUrl: './confirm-deletion.component.html',
  styleUrl: './confirm-deletion.component.scss'
})
export class ConfirmDeletionComponent implements AfterViewInit {
  confirmId: string | undefined = "";
  showError: boolean = false;

  constructor(
    private snack: SnackService,
    private deletionService: DeletionService
  ) {
      this.confirmId = window.location.href.split('/').pop();
      this.confirmId = this.confirmId?.split('?')[0];
  }

  ngAfterViewInit(): void {
    console.log(this.confirmId);
    this.confirm()
  }

  async confirm() {
    if (!this.confirmId) {
      this.snack.error({ error: { msg: { headline: "Missing Data", text: "Deletion is not possible. Please contact the support." } } });
      return;
    }

    const result = await this.deletionService.confirm(this.confirmId);

    if (
      result !== true ||
      typeof result === 'number'
    ) {
      this.showError = true;
    }
  }
}
